

import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import Picker from "emoji-picker-react";

import Button from '../../../../Button/Button';
// import ImageEditorLink from '../../../pages/NotPageFound/ImageEditorLink';
import InputEmoji from '../../../../Form/Input/InputEmoji';
import Input from '../../../../Form/Input/Input';
import Loader from '../../../../Loader/Loader';

import InputEmoji2 from '../../../../Form/Input/InputEmoji2';

import { useStore } from '../../../../../hook-store/store';
// import { 
//   getKuraBucketFileSignedUrl,
// } from '../../../../util/group/kura-bucket-file';

import { SOCKET_GROUP_URL } from '../../../../../App';
import { marks } from '../../../../../images/marks';
import classes from '../GroupTalkTextItem.module.css';

const GroupTalkTextReplyAction = (props) => {
  // console.log('GroupTalkTextItem-props', props);

  const { 
    inputData, 
    // userId, 
    // userColorList, 
    // groupAllMemberList,
    groupTextPostHandler,
    isTextPosting,
    showReplyModalHandler,
   } = props;

   console.log('inputData', inputData);
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    selectedGroupData,
    // selectedKuraFileData,
    // isGroupMember,
   } = store.groupStore;

  const [textInput, setTextInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const [inputStr, setInputStr] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [showAllOriText, setShowAllOriText] = useState(false);

  // console.log(inputStr)

  // console.log('store in GroupTalkTextItem', store);
  const textInputHandlerEmoji = (input, value) => {
    setTextInput(value);
    // console.log(commentInput);
  }

  const getInputHandler = (input) => {
    setTextInput(input);
  }


  const replyTextPostHandler = () => {
      groupTextPostHandler(
        textInput.trim(), 
        selectedGroupData._id,
        null,
        null,
        null,
        { originalTextId: inputData._id }
      );

      showReplyModalHandler(false);
  }

  const replyTextPostHandler2 = () => {
    groupTextPostHandler(
      inputStr.trim(), 
      selectedGroupData._id,
      null,
      null,
      null,
      { originalTextId: inputData._id }
    );

    showReplyModalHandler(false);
  };

  const onEmojiClick = (emojiObject, event) => {
    setInputStr((prevInput) => prevInput + emojiObject.emoji);
    // setShowPicker(false);
  };

  let emojiPickerStyle = {
    display: 'none',
  }

  if (showPicker) {
    emojiPickerStyle = {
      display: 'block',
      // width: "100%",
      maxWidth: "100%",
      paddingBottom: "2rem",
    }
  }


  let oriText = '';

  if (inputData && inputData.text && inputData.text.length > 0) {
    oriText = inputData.text;
  }

  if (inputData.text.length > 100) {
    oriText = (
      <span>
        <span>
          {inputData.text.slice(0,100)}....
        </span>
        <span
          onClick={() => {
            setShowAllOriText(!showAllOriText);
          }}
        >
          {' '}{marks.triangleDown}
        </span>
      </span>
      );
  }

  if (showAllOriText) {
    oriText = (
      <span 
        style={{ whiteSpace: "pre-line" }}
      >
        <span>
          {inputData.text}
        </span>
        <span
          onClick={() => {
            setShowAllOriText(!showAllOriText);
          }}
        >
          {' '}{marks.triangle}
        </span>
      </span>
    );
  }

  let textReplyBody2 = (
    <div>
      <div className={classes.groupTextItemReplyActionTitle}>
          {t('groupTalk.text103', 'Write reply message')}
      </div>

      {inputData && inputData.text && inputData.text.length > 0 && (
        <div>
          <div>{t("groupTalk.text110","message")}</div>
          <div className={classes.groupTextItemReplyActionOriText }>
            <span>
              {oriText}
            </span>
            {}
          </div>
        </div>
      )}

      <InputEmoji2 
        getInputHandler={setTextInput}
        nRows={3}
        emojiPickerStyle={{
          display: 'block',
          // width: "100%",
          maxWidth: "100%",
          paddingBottom: "2rem",
        }}
        // textAreaStyle={{width: "30%"}}
        inputValue={textInput}
      />

      <div className={classes.talkUploadActionButtons}>
        <Button mode="flat" type="submit"
          disabled={isTextPosting || isLoading}
          loading={isTextPosting || isLoading}
          onClick={() => {
            showReplyModalHandler();
          }}
        >
          {t('talkUpload12', 'Cancel')}
        </Button>
        <Button mode="raised" type="submit"
          disabled={isTextPosting || isLoading || !textInput.trim()}
          loading={isTextPosting || isLoading}
          onClick={() => {
            replyTextPostHandler();
          }}
        >
          {t('general.text26', 'Send')}
        </Button>
      </div>
    </div>
  );
  



  return (
    <Fragment>
      {/* <div>{textReplyBody}</div> */}

      <div>{textReplyBody2}</div>
    </Fragment>
  );
}

export default GroupTalkTextReplyAction;